export default __webpack_public_path__ + "static/903-4ccb98cfb9a61720986f218568462623.gif";